// Edit this one file, then publish through your normal GitHub/Vercel workflow.
export const sumoDidiMedia = {
  mode: "both", // "teaser", "trailer", or "both"
  trailerUrl: "https://www.youtube.com/watch?v=hJL9MdogzTk",
  trailerThumbnail: "https://i.ytimg.com/vi/hJL9MdogzTk/maxresdefault.jpg",
  releaseCopy: "", // Optional confirmed release announcement, displayed with Trailer.
  // Optional film updates apply to Home, Work and the Sumo Didi project page.
  // Leave empty to keep current data. Example: { year: 2026, logline: "..." }
  filmUpdates: {},
};

export function youtubeId(value) {
  try {
    const url = new URL(value);
    if (url.protocol !== "https:" && url.protocol !== "http:") return null;
    const host = url.hostname.toLowerCase();
    let id = "";
    if (host === "youtu.be") id = url.pathname.split("/")[1];
    else if (["youtube.com", "www.youtube.com", "m.youtube.com"].includes(host)) {
      id = url.searchParams.get("v") || "";
      if (!id && /^\/(shorts|embed|live)\//.test(url.pathname)) id = url.pathname.split("/")[2];
    }
    return /^[A-Za-z0-9_-]{11}$/.test(id) ? id : null;
  } catch { return null; }
}

export function mediaItems(config = sumoDidiMedia) {
  const teaser = {
    key: "teaser", label: "Teaser", provider: "Vimeo",
    url: "https://vimeo.com/1212360489",
    embed: "https://player.vimeo.com/video/1212360489?h=0&autoplay=1&title=1&byline=1&portrait=0",
    thumbnail: "/Sumo Didi Zee5 Teaser thumbnail 2.png",
    copy: "",
  };
  const id = youtubeId(config.trailerUrl);
  if (config.mode === "teaser" || !id) return [teaser];
  const trailer = {
    key: "trailer", label: "Trailer", provider: "YouTube",
    url: `https://www.youtube.com/watch?v=${id}`,
    embed: `https://www.youtube-nocookie.com/embed/${id}?autoplay=1&playsinline=1&rel=0`,
    thumbnail: config.trailerThumbnail, copy: config.releaseCopy,
  };
  return config.mode === "trailer" ? [trailer] : [trailer, teaser];
}

export function withSumoDidiUpdates(film) {
  return film?.id === "sumo-didi"
    ? { ...film, ...sumoDidiMedia.filmUpdates, id: "sumo-didi" }
    : film;
}
